<template>
  <v-overlay
    :value="activator"
    opacity="0.5"
  >
    <v-container class="rounded-xl">
      <v-card width="500" color="white" rounded class="rounded-xl">
        <v-card-title class="full-width third">
          <span class="d-flex justify-center flex-grow-1">Modifier la session récurrente</span>
          <v-icon size="28" color="white" class="justify-end" @click="changeConfirmationModal(false)">mdi-close</v-icon>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row no-gutters class="p0-16">
            <RadioGroup
              v-model="typeOfupdate"
              :rules="mandatoryRule"
              :options="options"
            />
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-checkbox
            v-if="!autoActionFlag"
            v-model="autoActionFlagAux"
            class="mt-0 ml-2"
            label="Ne plus me demander"
            color="third"
            light
            hide-details
          />
          <v-spacer />
          <v-btn
            color="third"
            :outlined="true"
            :large="true"
            rounded
            class="font-weight-bold my-3 text-center"
            @click="changeConfirmationModal(false)"
          >
            <v-icon size="24" color="third" right class="mx-0 px-4">mdi-arrow-u-left-top</v-icon>
            Annuler
          </v-btn>
          <v-btn
            color="third"
            :outlined="true"
            :large="true"
            rounded
            class="font-weight-bold my-3 text-center"
            light
            :disabled="!typeOfupdate"
            @click="closeConfirmationModal"
          >
            <v-icon size="24" color="third" right class="mx-0 px-4">mdi-plus</v-icon>
            Modifier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-overlay>
</template>

<script>
import { inject, computed, ref } from '@vue/composition-api';
import store from '@/store';
import { mandatoryRule } from '../../../helpers/utils';
import RadioGroup from '../../common/RadioGroup.vue';

export default {
  components: { RadioGroup },
  props: {
    activator: { type: Boolean },
    changeConfirmationModal: { type: Function, default: null },
    value: {
      type: String,
      default: null
    },
    changeRecurringSession: {
      type: Function,
      default: null
    },
    currentSession: {
      type: Object,
      default: null
    },
    oldSessionDetail: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    contentType: {
      type: String,
      default: null
    },
    typeOfAction: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const typeOfupdate = inject('typeOfupdate', null);
    const flagMapper = computed(() => {
      switch (true) {
        case (props.contentType === 'horse' && props.typeOfAction === 'add'):
          return 'horseAssignRecurring';
        default:
          return false;
      }
    });

    const autoActionFlag = computed(() => flagMapper.value ? store.state.autoActionFlags[flagMapper.value] : true);
    const autoActionFlagAux = ref(flagMapper.value ? store.state.autoActionFlags[flagMapper.value] : true);
    const closeConfirmationModal = () => {
      props.changeRecurringSession(false);
      if (flagMapper.value) {
        store.commit('setAutoActionFlags', { type: flagMapper.value, value: autoActionFlagAux.value });
      }
    };

    return { typeOfupdate, mandatoryRule, closeConfirmationModal, autoActionFlag, autoActionFlagAux };
  }
};
</script>

<style>
  .v-radio .v-icon {
   color: black;
  }

  #deleteOptions.v-radio .v-icon {
   color: black;
  }
</style>
